import { internalNetworkClient } from '@terra/shared-rest-clients-internal-network';
import type {
  InternalNetworkContract,
  UpdateInternalNetworkDto,
} from '@terra/shared-contracts-internal-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const internalNetworkScopeApi = {
  updateInternalNetworkScope: ({
    networkId,
    body,
  }: {
    networkId: string;
    body: UpdateInternalNetworkDto;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.update>({
      endpointFn: (headers) =>
        internalNetworkClient.update({
          params: { networkId },
          body,
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  deleteInternalNetworkCrownJewel: ({
    networkId,
    crownJewelId,
  }: {
    networkId: string;
    crownJewelId: string;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.deleteCrownJewel>({
      endpointFn: (headers) =>
        internalNetworkClient.deleteCrownJewel({
          params: { networkId, crownJewelId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  revokeInternalNetworkOwnedPrincipal: ({
    networkId,
    entityId,
  }: {
    networkId: string;
    entityId: string;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.revokeOwnedPrincipal>({
      endpointFn: (headers) =>
        internalNetworkClient.revokeOwnedPrincipal({
          params: { networkId, entityId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),
};
